import React from "react";

const RenderErrorPage: React.FC = () => {
  throw new Error("Simulated error at render function");
};

export default RenderErrorPage;
